/**
 * Mock storage service.
 * Returns placeholder URLs instead of uploading to Firebase Storage.
 */
import { mockDelay, mockLog } from './mock-delay';

export const uploadPostImage = async (file, postId, onProgress) => {
  mockLog('StorageService', 'uploadPostImage', postId);
  if (onProgress) onProgress(50);
  await mockDelay(300, 600);
  if (onProgress) onProgress(100);
  return `https://placehold.co/600x400/e8e8e8/666?text=Post+Image`;
};

export const deletePostImage = async (imageUrl) => {
  mockLog('StorageService', 'deletePostImage');
  await mockDelay(50, 150);
};

export const uploadAvatar = async (file, userId, onProgress) => {
  mockLog('StorageService', 'uploadAvatar', userId);
  if (onProgress) onProgress(50);
  await mockDelay(300, 600);
  if (onProgress) onProgress(100);
  return `https://i.pravatar.cc/150?u=${userId}_${Date.now()}`;
};

export const uploadCoverPhoto = async (file, userId, onProgress) => {
  mockLog('StorageService', 'uploadCoverPhoto', userId);
  if (onProgress) onProgress(50);
  await mockDelay(300, 600);
  if (onProgress) onProgress(100);
  return `https://placehold.co/1200x400/e8e8e8/666?text=Cover+Photo`;
};
